import {DashboardDeviceActions, DashboardDeviceActionTypes} from '../actions/dashboard-device.actions';
import {DeviceSelectionMode} from '../enums/device-selection-mode.enum';
import {AddSelectedDevicePayload, RemoveSelectedDevicePayload, SetSelectedDevicePayload} from '../models/dashboard-device';

export interface State {
  selectedDeviceUuids: string[];
  deviceSelectionMode: DeviceSelectionMode;
}

export const initialState: State = {
  selectedDeviceUuids: [],
  deviceSelectionMode: DeviceSelectionMode.Single
};

export function reducer(state = initialState, action: DashboardDeviceActions): State {
  switch (action.type) {

    case DashboardDeviceActionTypes.AddSelectedDevice: {
      const addSelectedDevicePayload: AddSelectedDevicePayload = action.payload;
      const index = state.selectedDeviceUuids.findIndex(
        (selectedDeviceUuid: string) => selectedDeviceUuid === addSelectedDevicePayload.deviceUuid);
      // To check if selected device already exists in the list
      // Add if not in the list; return the existing list if already in the list
      return {
        ...state,
        selectedDeviceUuids: index === -1 ? [...state.selectedDeviceUuids, addSelectedDevicePayload.deviceUuid]
          : [...state.selectedDeviceUuids]
      };
    }

    case DashboardDeviceActionTypes.RemoveSelectedDevice: {
      const removeSelectedDevicePayload: RemoveSelectedDevicePayload = action.payload;
      const filteredUuidList: string[] = state.selectedDeviceUuids
        .filter((selectedDeviceUuid: string) => !(selectedDeviceUuid === removeSelectedDevicePayload.deviceUuid));

      return {
        ...state,
        selectedDeviceUuids: filteredUuidList
      };
    }

    case DashboardDeviceActionTypes.SetSelectedDevice: {
      const setSelectedDevicePayload: SetSelectedDevicePayload = action.payload;

      return {
        ...state,
        selectedDeviceUuids: setSelectedDevicePayload.deviceUuids
      };
    }

    case DashboardDeviceActionTypes.EmptySelectedDevice: {
      return {
        ...state,
        selectedDeviceUuids: []
      };
    }

    case DashboardDeviceActionTypes.SetDeviceSelectionMode: {
      const selectionMode: DeviceSelectionMode = action.payload;
      return {
        ...state,
        deviceSelectionMode: selectionMode
      };
    }

    default:
      return state;
  }
}

export const selectedDeviceUuids = (state: State) => state.selectedDeviceUuids;
export const deviceSelectionMode = (state: State) => state.deviceSelectionMode;
